import { IOffice } from 'office/IOffice'
import { atom } from 'recoil'

export const OfficesRecoilState = atom<IOffice[] | null>({
  key: 'officesRecoilState',
  default: null,
})
